import styled from "styled-components"

const S = {}

S.OfferWrapper = styled.div`
  max-width: 1200px;
  padding-top: 120px;
  margin: 0 auto;
  /* height: 80vh; */

  @media (max-width: 768px) {
    margin: 0px 15px 0px 15px;
    height: initial;
  }

  & .lighten {
    padding: 30px 50px;
    background: #000000cc;
    color: #fff;
    font-weight: 400;
    border-radius: 5px 35px 5px 35px;
    letter-spacing: 2px;

    @media (max-width: 768px) {
      letter-spacing: 0;
      font-size: 16px;
    }
  }
`

S.OfferTitle = styled.h2`
  text-align: center;
  color: #343434;
  font-size: 32px;
  font-weight: 100;
  margin-bottom: 10px;
`

S.OfferDescription = styled.p`
  margin: 60px 0;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0px;
  font-weight: 100;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  a {
    text-decoration: none;
    font-weight: 700;
    color: #dc8313f7;
  }
`

S.OfferIconsWrapper = styled.div`
  margin: 120px 0;
  & ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    align-items: center;
    justify-content: space-around;

    @media (max-width: 768px) {
      flex-direction: column;

      & li {
        margin-bottom: 40px !important;
      }
    }

    & li {
      font-size: 100px;
      color: #22283b;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      margin: 0 16px;

      & svg {
        width: 120px;
        height: 120px;
      }

      & span {
        margin-top: 15px;
        font-size: 20px;
        text-align: center;
      }
    }
  }
`

S.IconWrapper = styled.img`
  width: 120px;
  height: 120px;
`

export default S
